'use client';

import { c as _c } from "react/compiler-runtime";
import { useContext } from 'react';
import { DisclosurePanel } from '@headlessui/react';
import AttachmentsToolbarContext from '../AttachmentsToolbar.context';
import { removeAttachmentAction } from '../AttachmentsToolbar.module';
import AttachmentsToolbarItem from './AttachmentsToolbarItem';
import type { DisclosurePanelProps } from '@headlessui/react';
const baseClassName = ['max-h-96', 'overflow-y-auto'].join(' ');
const AttachmentsToolbarBody = t0 => {
  const $ = _c(4);
  const context = useContext(AttachmentsToolbarContext);
  let t1;
  if ($[0] !== context) {
    t1 = context.attachments.map(attachment => <AttachmentsToolbarItem key={`attachment-${attachment.attachment_id}`} remove={() => {
      context.dispatch(removeAttachmentAction({
        attachment_id: attachment.attachment_id
      }));
    }} {...attachment} />);
    $[0] = context;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <DisclosurePanel className={baseClassName}>{t1}</DisclosurePanel>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
export default AttachmentsToolbarBody;